<template>
    <div>
        <div class="newOne">
            <div class="content">
                <h2>垃圾分类，风雨无阻</h2>
                <p class="p-1"><span class="span-1">纸搬客</span>2020年7月31号</p>
                <div class="details">
                    <!-- <img src="../../assets/img/newTwo/1.png" alt="" class="img-2"> -->
                    <p class="p-1 p-spe">七月流火、酷暑难耐，久违的降雨给酷热中的首都人民带来了一丝清爽。垃圾分类是今年北京市政府工作的一项重要内容，全市各小区都在积极开展相关工作。在我们所走访的众多小区中，居民无论是从环保意识还是实际行动上都给予了垃圾分类工作巨大的支持，在这里我们为首都人民点赞！</p>
                    <img src="../../assets/img/newSeven/1.png" alt="" class="img-2">
                    <!-- <p class="p-1 p-spe">在“世界地球日”当天，纸搬客入驻社区-南华里社区受邀接受来自“首都财经频道”的记者采访</p> -->
                    <p class="p-1 p-spe">在密云云秀花园小区走访时我们发现，小区居民对新进驻的纸搬客智能废纸回收机非常喜爱，哪怕是遇上了下雨天气，也都能看到有居民在围观学习和排队碎纸。用小区居民张大爷话来说：“自从有了纸搬客，家里再也不用堆积废纸垃圾了，增大了储物空间的同时，还降低了安全隐患，你们要是早点来就好了！”。</p>
                    <img src="../../assets/img/newSeven/2.png" alt="" class="img-2">
                    <!-- <p class="p-3">（左：南华里物业经理杨玉全      右：纸搬客创始人兼CEO李嘉轩”）</p> -->
                    <p class="p-1 p-spe">垃圾分类工作任务繁重，需要全国人民上下齐心一起努力。纸搬客作为具备互联网基因的智能废纸回收创新模式，希望在废纸回收方面持续为垃圾分类工作做一点贡献，也为小区居民带来更多的实惠。垃圾分类，风雨无阻，纸搬客与您在一起！</p>
                    <!-- <img src="../../assets/img/newSeven/3.png" alt="" class="img-2"> -->
                    <!-- <p class="p-3 p-bottom">（左：纸搬客用户“陈大妈”        右：纸搬客用户“郭大爷”）</p> -->
                </div>
            </div>
            <!-- footer -->
            <footer_s></footer_s>
        </div>
    </div>
</template>
<script>
    import footer_s from '../common/footer'
    export default {
        components: {
            footer_s
        },
    }
</script>
<style scoped>
    .newOne {
        width: 100%;
        min-height: 3.4rem;
        position: absolute;
        background-color: #fff;
        top: 0rem;
        left: 0;
        z-index: 100;
    }
    .content{
        width: 60%;
        min-height: 3.4rem;
        margin: 0 auto;
        padding: 0 5%;
    }
    .content h2 {
        font-size: 0.13rem;
        font-family: PingFang SC;
        font-weight: bold;
        color: rgba(14, 14, 14, 1);
        line-height: 0.2rem;
        margin-top: 0.1rem;
    }
    .span-1{
        font-size: 0.06rem;
        margin-right: 0.03rem;
        color: #576b95;
    }
    .p-1 {
        font-size: 0.048rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #444;
        line-height: 0.1rem;
        margin-top: 0.03rem;
    }
    .details{
        width: 100%;
    }
    .p-2{
        font-size:0.04rem;
        font-family:PingFang SC;
        font-weight:500;
        color: #444;
        line-height:0.1rem;
        margin-bottom: 0.05rem;
    }
    .p-spe{
        text-indent: 2em;
    }
    .img-2{
        width: 100%;
        height: 100%;
        margin-top: 0.07rem;
    }
    .p-3{
        color: rgb(136, 136, 136);
        text-align: center;
        font-size: 0.04rem;
    }
    .p-bottom{
        margin-bottom: 0.3rem;
    }
</style>


// WEBPACK FOOTER //
// src/views/newChild/newSeven.vue